//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNavigationInfo } from '../utils'
export default {
    props: {
        tabs: {
            type: Array,
            default: []
        },
        show: {
            type: Boolean,
            default: false
        },
        position: {
            type: String
        }
    },
    data () {
        return {
            height: 0
        }
    },
    mounted () {
        this.$nextTick(() => {
            const query = this.$mp.component.createSelectorQuery()
            query.select('#top-module-tabs').boundingClientRect()
            query.exec(([data]) => {
                if (data && data.height) {
                    this.$emit('changeHeight', data.height)
                }
            })
        })
    },
    methods: {
        backHome () {
            wx.pageScrollTo({
                scrollTop: 0,
                success: () => {
                    this.$emit('hide')
                }
            })
        },
        clickTab (id, tab_id) {
            this.$emit('changePosition', id, tab_id)
        }
    }
}
